export default "__VITE_ASSET__7dc693ad__"